/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import classnames from 'classnames';
import Draggable from 'react-draggable';
import { Modal } from 'antd';
import useDraggableModalWrapper from './useDraggableModalWrapper';
import './styles.scss';

type DraggableModalWrapperProps = {
  visible: boolean;
  className?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
};

/**
 * Renders an antd Modal the user can drag around by a handle strip in its title area. Keeps disabled and bounds in merged state, enabling dragging only while the pointer is over the drag zone, and wires modalRender through Draggable with a ref used to clamp movement to the viewport.
 *
 * @param props - Wrapper props carrying className, visible and the modal children.
 * @returns The rendered draggable modal containing the supplied children.
 */
const DraggableModalWrapper = ({
  visible,
  className,
  children,
  ariaLabel,
}: DraggableModalWrapperProps) => {
  const { state, setState, draggleRef, onStart } = useDraggableModalWrapper();

  return (
    <Modal
      mask={false}
      closable={false}
      className="draggable-modal"
      wrapClassName={classnames('draggable-modal-wrapper', className)}
      footer={null}
      title={
        <div
          className="drag-zone"
          onMouseOver={() => {
            if (state.disabled) {
              setState({
                disabled: false,
              });
            }
          }}
          onMouseOut={() => {
            setState({
              disabled: true,
            });
          }}
          onFocus={() => {}}
          onBlur={() => {}}
        >
          {!!ariaLabel && <span className="sr-only">{ariaLabel}</span>}
          <div className="drag-handle" />
        </div>
      }
      open={visible}
      modalRender={(modal: any) => (
        <Draggable
          disabled={state.disabled}
          bounds={state.bounds}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
    >
      {children}
    </Modal>
  );
};

export default DraggableModalWrapper;
